import React from 'react';
import SidebarUnitDesktop from "components/sidebar/components/SidebarUnitDesktop";
import { StarIcon } from "assets/icons";

const MissionTemplateLink = () => {
    return (
        <SidebarUnitDesktop
            routeName={"Fiches de postes"}
            routeSidebar={"/missionTemplates"}
            icon={StarIcon}
            text={"Fiches de postes"}
        />
    );
};

export default MissionTemplateLink;
